import React from 'react';
import PropTypes from 'prop-types';

import 'styled-components/macro';

import Button from '../Button';

import StyledRefinedHeader, {
  Container,
  LogoContainer,
  Logo,
  TextButton,
} from './RefinedHeader.styles';
import IconArrow from '../../images/IconArrow';
import LogoSVG from '../../images/vector-logoMaxilloQuebec.svg';

const RefinedHeader = ({ larger }) => {
  return (
    <StyledRefinedHeader>
      <Container larger={larger}>
        <LogoContainer>
          <h2>
            <Logo src={LogoSVG} alt='Maxillo Québec' />
          </h2>
        </LogoContainer>

        <Button
          outlined
          primary
          renderIcon={<IconArrow style={{ transform: 'rotate(180deg)' }} />}
          iconFirst
          to='/'
        >
          <TextButton>Page précédente</TextButton>
        </Button>
      </Container>
    </StyledRefinedHeader>
  );
};

RefinedHeader.propTypes = {
  larger: PropTypes.bool,
};

RefinedHeader.defaultProps = {
  larger: false,
};

export default RefinedHeader;
